





























































































































































































































































import {
  Component,
  Prop,
  Emit,
  ProvideReactive,
  mixins,
} from 'nuxt-property-decorator'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import PlanDetailRange from '../sales_map_v3/PlanDetailRange.vue'
import AvailableLotCardList from './AvailableLotCardList.vue'
import DirectionsMap from '~/components/consumer_map/DirectionsMap.vue'
import VirtualTourWrapper from '~/components/shared/VirtualTourWrapper.vue'
import ImagesGallery from '~/components/shared/imagesGallery.vue'
import PlanCardV3 from '~/components/sales_map_v3/PlanCardV3.vue'
import ElevationCardV3 from '~/components/consumer_map_v3/ElevationCardV3.vue'
import Map from '~/components/consumer_map/Map.vue'
import Lot from '~/models/lot'
import { PublicProject } from '~/models/project'
import Plan from '~/models/plan'
import { LotTypes } from '~/enums/lots'
import { getElevations } from '~/api/elevations.api'
import { getLots } from '~/api/lot.api'
import { Elevation, LotAvailable } from '~/models'
import DotFlashing from '~/components/shared/DotFlashing.vue'
import 'swiper/css/swiper.css'
import { isItemInFavs, storageAvailable } from '~/utils/localStorage'
import DefaultImage from '~/mixins/defaultImage'
import SalesTeamDetails from '~/components/sales_map_v3/SalesTeamDetails.vue'
import { ElevationStatus } from '~/enums/construction'
import Document from '~/models/document'
import { hasHTMLCode } from '~/utils/htmlDetection'
import { checkHideHomePricing } from '~/utils/plans'

@Component({
  components: {
    Swiper,
    SwiperSlide,
    VirtualTourWrapper,
    DirectionsMap,
    ImagesGallery,
    PlanCardV3,
    ElevationCardV3,
    Map,
    DotFlashing,
    PlanDetailRange,
    AvailableLotCardList,
    SalesTeamDetails,
  },
  mixins: [DefaultImage],
})
export default class HomeViewSidePanel extends mixins(DefaultImage) {
  @Prop({ default: null }) plan: Plan
  @Prop({ default: null }) models: Array<Lot>
  @Prop({ default: null }) selectedPlanId: number
  @Prop({ default: null }) selectedElevationId: number
  @Prop({ default: null }) lots: Array<Lot>
  @Prop({ default: null }) project: PublicProject
  @Prop({ default: null }) redirectModel: Function

  showVirtualTour: boolean = false
  currentSlideImage: number = 1
  streetViewMeta = { status: 'ZERO_RESULTS' }
  lotType: string = LotTypes.HOME
  elevations: Array<Elevation> = []
  planSelectorHeight: number = 400
  resizeWindowListener: any

  isSaved: Boolean = false
  showShareModal: Boolean = false
  sharedUrl: string = ''

  planSelected: Plan = null
  elevationsLoading: boolean = false
  elevationSelected: Elevation = null
  availableLots: Array<LotAvailable> = []
  lotsLoading: boolean = false
  lotSelected: number | Lot = null

  urlLotId: number = null
  favoriteWatch: any = null

  @ProvideReactive() loSidebarHover: any = null
  @ProvideReactive() queryFilters: string = ''

  onLotListHover(lotInfo: any): void {
    this.loSidebarHover = {
      centerpoint: lotInfo.centerpoint,
      parcel_id: lotInfo.parcel_id,
    }
  }

  mounted(): void {
    this.planSelected = this.plan
    if (Object.keys(this.$route.query).includes('elevation_id')) {
      const elevation_id: number = parseInt(
        this.$route.query.elevation_id as string
      )
      if (Object.keys(this.$route.query).includes('lot_id')) {
        this.urlLotId = parseInt(this.$route.query.lot_id as string)
      }
      this.getElevations(this.plan.id, elevation_id)
    } else {
      this.getElevations(this.plan.id)
    }

    this.resizeWindowListener = window.addEventListener(
      'resize',
      this.setWindowSize
    )
    this.setWindowSize()

    this.favoriteWatch = this.$store.watch(
      () => this.$store.getters['favorites/favCount'],
      (val, oldVal) => {
        if (val !== oldVal && storageAvailable()) this.updateSaved()
      }
    )
    if (storageAvailable()) this.updateSaved()
  }

  unmounted(): void {
    window.removeEventListener('resize', this.resizeWindowListener)
  }

  updateSaved() {
    const planId = this.planSelected?.id
    const elevationId = this.elevationSelected?.id
    this.availableLots.forEach(
      (lot) =>
        (lot.isSaved = isItemInFavs(
          {
            id: String(lot.id),
            plan_id: planId ? String(planId) : null,
            elevation_id: elevationId ? String(elevationId) : null,
          },
          'lot'
        ))
    )
    this.availableLots = [...this.availableLots]
  }

  setWindowSize() {
    if (window.visualViewport) {
      this.planSelectorHeight = window.visualViewport.height - 100
    } else {
      this.planSelectorHeight = window.innerHeight - 100
    }
  }

  get model() {
    const foundModel =
      this.models?.length &&
      this.models.find(
        (model: any) => model?.builder?.name === this.plan.builder?.name
      )
    return this.redirectModel(foundModel)
  }

  get additionalDetails() {
    const details = {
      Plan: this.plan.name,
      Architecture: this.elevationSelected?.style?.name,
      'Lot Size': this.elevationSelected?.plan?.size.join(','),
    }
    return Object.entries(details)
  }

  async getElevations(
    planId: number,
    selectedElevationId: number | null = null
  ): Promise<void> {
    this.elevationsLoading = true
    try {
      const response = await getElevations(
        null,
        null, // this.lotInfo?.id,
        null,
        null,
        'max',
        null,
        null, // this.$route.params.slug,
        null, // this.lotInfo?.builder?.id,
        false,
        planId,
        null // parseHomeParams(filtersApplied)
      )
      this.elevations = response.results

      if (selectedElevationId) {
        this.onElevationSelection(selectedElevationId)
      }
    } catch (error) {
      throw new Error(error)
    } finally {
      this.elevationsLoading = false
    }
  }

  async getLots(projectId: number, elevationId: number): Promise<void> {
    this.lotsLoading = true
    try {
      const response = await getLots(projectId, elevationId)
      this.availableLots = response
      this.updateSaved()
      this.scrollLotSelectorIntoView()
    } catch (error) {
      throw new Error(error)
    } finally {
      this.lotsLoading = false
    }
  }

  scrollLotSelectorIntoView(): void {
    const scrollElement = document.querySelector('#plan-finder')
    const lotToBuildElement = document.querySelector('#choose-lot-to-build')
    if (!lotToBuildElement) {
      return
    }
    const lotToBuildElementRect = lotToBuildElement.getBoundingClientRect()
    scrollElement.scrollBy({
      top: lotToBuildElementRect.bottom - 200,
      behavior: 'smooth',
    })
  }

  @Emit('elevationSelection')
  onElevationSelection(value: number): {
    id: number
    name: string
    slug: string
  } {
    this.elevationSelected = this.elevations.find(
      (elevation) => elevation.id === value
    )
    this.getLots(this.project.id, this.elevationSelected.id)
    return {
      id: this.elevationSelected.id,
      name: this.elevationSelected.name,
      slug: this.elevationSelected.slug,
    }
  }

  @Emit('lotSelection')
  onSelectAvailableLot(value: number): number {
    return value
  }

  @Emit('saveFav')
  saveFav(value: number): number {
    return value
  }

  get virtualTour(): string {
    return this.planSelected?.virtual_tour_url || null
  }

  setShowVirtualTour(value: boolean): void {
    this.showVirtualTour = value
  }

  get gallery(): Array<string> | Array<Document> {
    const singleImage: string = this.plan.image

    const photos = this.plan.interior_photos
      .map((photo) => photo.source)
      .filter((photo) => photo !== undefined)

    const applicableElevationImage = this.applicableElevations
      .map((elevation) => elevation.photo)
      .filter((photo) => photo !== undefined)[0]

    const allImages: string[] = []

    if (singleImage) {
      allImages.push(singleImage)
    }

    if (applicableElevationImage) {
      allImages.push(applicableElevationImage.toString())
    }

    if (photos.length > 0) {
      allImages.push(...photos)
    }

    return allImages.length > 0 ? allImages : [this.defaultImage()]
  }

  get floorPlanGallery(): Array<string> | Array<Document> {
    if (this.planSelected) {
      const photos = this.planSelected.floor_plan_images
        .map((photo: { source: string }) => photo.source)
        .filter((photo: any) => photo !== undefined)

      return photos.length > 0 ? photos : [this.defaultImage()]
    }
  }

  get applicableElevations() {
    return this.elevations.filter(
      (elevation) =>
        this.planSelected.id === elevation.plan.id &&
        elevation.status === ElevationStatus.APPROVED
    )
  }

  hasHTMLCode(value: string): boolean {
    return hasHTMLCode(value)
  }

  get hideHomePricing(): boolean {
    return checkHideHomePricing(this.plan)
  }

  get hideConsumerMap(): boolean {
    return this.project?.config?.hide_map_consumer_map_v3 || false
  }
}
